import React from 'react';
import Tooltip from './Tooltip.jsx'

const MultilangValue = ({value, valueLocale}) => {
  if (!value || !valueLocale) return value;

  return (
    <>
      {valueLocale !== I18n.locale &&
        <Tooltip title={`${I18n.t('value_from_different_locale')}: ${I18n.t(valueLocale+'_long')}`}>
          <i className='fa fa-language' style={{marginRight: '5px'}}/>
        </Tooltip>
      }
      {value}
    </>
  )
}

export default MultilangValue;
